import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { OVERVIEW_TYPE } from './overview.define';
import { useDatabaseOverviewStore } from '../stores/database-overview';
import { DB_TYPE } from '@/common/define/common.define';
import { useSingleStoreClusterInstance } from './overview.uses';
import { lowerCase } from 'lodash-es';
import { GetV9AlertsAlertRulesCurrentPlatformTypesItem } from '@/api-client/alert/model';

export type InstanceId = string;
interface CurrentRouteInfo {
  dbType: string;
  view: string;
}

const checkViewName = (view: string) => {
  if (view === 'ClusterView') {
    return 'MultiView';
  }
  return view;
};

export const useInstanceIds = () => {
  const route = useRoute();
  const overviewStore = useDatabaseOverviewStore();
  const { getInstanceIdsByClusterId } = useSingleStoreClusterInstance();

  const currentRouteInfo = computed<CurrentRouteInfo>(() => {
    if (!route?.name) {
      return { dbType: '', view: '' };
    }
    const dividedName = typeof route.name === 'string' ? route.name.split('_') : [];
    return {
      dbType: dividedName[0] ?? '',
      view: dividedName[1] ? checkViewName(dividedName[1].replaceAll(' ', '')) : '',
    };
  });

  const getInstanceIds = (): InstanceId[] => {
    const { dbType, view } = currentRouteInfo.value;

    if (!dbType || !view) {
      return [];
    }

    if (view === 'MultiView') {
      if (dbType === DB_TYPE.SINGLESTORE) {
        const clusterId = overviewStore.getLastSelectedOverviewId({
          dbType,
          viewType: OVERVIEW_TYPE.CLUSTER_VIEW,
        });
        return getInstanceIdsByClusterId(clusterId);
      }
      return overviewStore.getLastInstanceIds({ dbType });
    }

    const instanceId = overviewStore.getLastSelectedOverviewId({
      dbType,
      viewType: OVERVIEW_TYPE.SINGLE_VIEW,
    });
    return instanceId ? [instanceId] : [];
  };

  return {
    currentRouteInfo,
    getInstanceIds,
  };
};

export const getAlertWithoutNormal = (data: { alertLevel?: string }[]) => {
  return data.filter((alert) => lowerCase(alert.alertLevel ?? '') !== 'normal');
};

export const DATABASE_ALERT_CURRENT_PLATFORM_TYPES: GetV9AlertsAlertRulesCurrentPlatformTypesItem[] =
  [
    GetV9AlertsAlertRulesCurrentPlatformTypesItem.database,
    GetV9AlertsAlertRulesCurrentPlatformTypesItem.database_cluster,
  ];
